import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import './Main.scss'
import axios from 'axios';
import MainURL from '../../MainURL';
import { useNavigate } from 'react-router-dom';
import { DateFormatExact } from '../../components/DateFormmating';
import { motion } from "framer-motion";import defaultMainImage from '../../images/mainimage.jpg';
import MainPopup from '../../components/MainPopup';

interface ListProps {
  id : number;
  sort : string;
  title : string;
  content : string;
  userAccount : string;
  userNickName : string;
  isLiked : string;
  date : string;
  views : string;
  images : [string]
}

interface GalleryItem {
  subtitle : string,
  date : string;
  image : string;
}

// 스크롤 등장 애니메이션
const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 16 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.65, delay, ease: [0.22, 0.61, 0.36, 1] as any },
  viewport: { once: true, amount: 0.1 },
});

export default function Main(props:any) {

	let navigate = useNavigate();

  const goTo = (path: string, state?: any) => {
    window.scrollTo(0, 0);
    navigate(path, state ? { state } : undefined);
  };

  const [list, setList] = useState<ListProps[]>([]);
  const fetchDatas = async () => {
    const res = await axios.get(`${MainURL}/board/getposts/1`);
    if (res.data) {
      const copy = res.data.resultData;
      setList(copy);
    }
  }

  useEffect(()=>{
    fetchDatas();
  }, []);

  const [program, setProgram] = useState<GalleryItem[]>([]);

  // 프로그램 진행 현황 가져오기
  const fetchPosts = async () => {
    try {
      const progRes = await axios.get(`${MainURL}/main/getgalleryprogram`);
      if (progRes.data && Array.isArray(progRes.data)) {
        setProgram(progRes.data);
      } else {
        setProgram([]);
      }
    } catch (e) {
      console.error('메인 갤러리 로드 오류:', e);
      setProgram([]);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  // 메인 배경 이미지 (관리자 설정, 없으면 기본 이미지)
  const [mainBgImage, setMainBgImage] = useState<string>('');
  const fetchMainBg = async () => {
    try {
      const res = await axios.get(`${MainURL}/main/getmaininfo`);
      if (res.data && res.data.length > 0) {
        setMainBgImage(res.data[0].imageMainName || '');
      }
    } catch (e) {
      console.error('메인 배경 이미지 로드 오류:', e);
    }
  };

  useEffect(() => {
    fetchMainBg();
  }, []);

  const heroBg = mainBgImage
    ? `url('${MainURL}/images/mainimages/${mainBgImage}'), url('${defaultMainImage}')`
    : `url('${defaultMainImage}')`;

	return (
		<div className='main'>

      <MainPopup/>

      {/* ══════ 메인 배너 ══════ */}
      <section className="main_hero">
        <div className="main_hero__bg" style={{ backgroundImage: heroBg }}></div>
        <div className="main_wrap main_hero__in">
          <motion.p className="main_hero__mark" {...reveal()}>노숙인자활시설</motion.p>
          <motion.h1 {...reveal(0.08)}>“당신의 자립과 회복을 <em>응원합니다</em>”</motion.h1>
          <motion.p className="main_hero__sub" {...reveal(0.16)}>
            어려움을 겪는 이들이 다시 일어설 수 있도록 돕는 따뜻한 공간,
            새삶공동체입니다. <b>단순한 숙소를 넘어</b> 자립과 회복을 위한 맞춤형 지원을 제공합니다.
          </motion.p>
          <motion.div className="main_hero__cta" {...reveal(0.24)}>
            <button className="main_btn main_btn--white" onClick={()=>goTo('/supporter')}>후원하기</button>
            <button className="main_btn main_btn--line" onClick={()=>goTo('/notice')}>시설소개 보기</button>
          </motion.div>
        </div>
      </section>

      {/* ══════ 프로그램 진행 ══════ */}
      <section className="main_sec">
        <div className="main_wrap">
          <motion.div className="main_sec__head" {...reveal()}>
            <div>
              <p className="main_sec__label">새삶이야기</p>
              <h2>함께 만들어가는 프로그램</h2>
              <p className="hint">새삶공동체에서 진행된 다양한 프로그램과 활동 소식을 전합니다.</p>
            </div>
            <button className="main_btn main_btn--ghost main_btn--sm" onClick={()=>goTo('/programImage')}>자세히보기</button>
          </motion.div>

          {
            program.length > 0
            ?
            <ul className="main_sup">
              {/* 서버에서 최신순으로 내려옴 */}
              {program.slice(0, 3).map((item, index) => (
                <motion.li key={index} {...reveal(index * 0.08)}
                  onClick={()=>goTo('/programImage')}
                >
                  <div className="thumb">
                    <img src={`${MainURL}/images/gallery/${item.image}`} alt={item.subtitle || '프로그램 사진'} />
                  </div>
                  <b>{item.subtitle}</b>
                  {item.date && <span className="date">{item.date}</span>}
                </motion.li>
              ))}
            </ul>
            :
            <p className="main_empty">등록된 프로그램이 없습니다.</p>
          }
        </div>
      </section>

      {/* ══════ 공지사항 ══════ */}
      <section className="main_sec main_sec--soft">
        <div className="main_wrap">
          <motion.div className="main_sec__head" {...reveal()}>
            <div>
              <p className="main_sec__label">공지사항</p>
              <h2>새삶공동체 소식</h2>
            </div>
            <button className="main_btn main_btn--ghost main_btn--sm" onClick={()=>goTo('/board')}>자세히보기</button>
          </motion.div>

          <ul className="main_notice">
          {
            list.length > 0
            ?
            list.map((item, index) => (
              <motion.li key={index} {...reveal()}
                onClick={()=>goTo('/boarddetail', item)}
              >
                <b>{item.title}</b>
                <span className="meta">
                  <span>{DateFormatExact(item.date)}</span>·<span>조회 {item.views ?? 0}</span>
                </span>
              </motion.li>
            ))
            :
            <li className="empty"><b>작성된 글이 없습니다.</b></li>
          }
          </ul>
        </div>
      </section>

			<Footer />

		</div>
	);
}
